import { render, staticRenderFns } from "./RecordsTable.vue?vue&type=template&id=2ff41ae7&scoped=true&"
import script from "./RecordsTable.vue?vue&type=script&lang=js&"
export * from "./RecordsTable.vue?vue&type=script&lang=js&"
import style0 from "./RecordsTable.vue?vue&type=style&index=0&id=2ff41ae7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff41ae7",
  null
  
)

export default component.exports